.root { display: flex; height: 100%; min-height: 0; min-width: 0; }
.row { flex-direction: row; }
.column { flex-direction: column; }
.first { flex: 0 0 var(--first); min-width: 0; min-height: 0; overflow: hidden; }
.second { flex: 1 1 0; min-width: 0; min-height: 0; overflow: hidden; }
.divider { position: relative; flex: none; background: var(--color-border); touch-action: none; }
.row > .divider { width: 1px; cursor: col-resize; }
.column > .divider { height: 1px; cursor: row-resize; }
/* Wide invisible hit area, visible purple line only while dragging or focused */
.divider::before { content: ""; position: absolute; inset: -4px; }
.row > .divider::before { inset: 0 -4px; }
.column > .divider::before { inset: -4px 0; }
.divider::after { content: ""; position: absolute; inset: 0; background: var(--color-primary); opacity: 0; transition: opacity var(--duration-fast) ease; }
.divider:hover::after, .divider:focus-visible::after, .divider:active::after { opacity: 1; }
.row > .divider::after { inset: 0 -1px; }
.column > .divider::after { inset: -1px 0; }
.divider:focus-visible { box-shadow: none; }
